import { useContext } from 'react';
import { OptionContext } from '../contexts/OptionContext';

const useOptionContext = () => {
  const context = useContext(OptionContext);

  if (!context) {
    throw new Error('useOptionContext must be used within a OptionContextProvider');
  }

  return context;
};

export default useOptionContext;
